/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Historicallows_Error1Inputs */

const en_us2_home_historicallows_error1 = /** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historical-low offers could not be loaded.`)
};

const es_es2_home_historicallows_error1 = /** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar las ofertas con mínimo histórico.`)
};

const ru_home_historicallows_error1 = /** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить предложения с исторически минимальными ценами.`)
};

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const id_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const ms_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const da_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const de_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const es_mx2_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const fil_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const fr_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const it_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const hu_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const nl_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const no_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const pl_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const pt_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const pt_br2_home_historicallows_error1 = pt_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const ro_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const fi_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const sv_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const vi_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const tr_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const cs_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const bg_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const uk_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const ar_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const hi_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const th_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const ja_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const zh_cn2_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const zh_hant1_home_historicallows_error1 = en_us2_home_historicallows_error1;

/** @type {(inputs: Home_Historicallows_Error1Inputs) => LocalizedString} */
const ko_home_historicallows_error1 = en_us2_home_historicallows_error1;

/**
* | output |
* | --- |
* | "Historical-low offers could not be loaded." |
*
* @param {Home_Historicallows_Error1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_historicallows_error1 = /** @type {((inputs?: Home_Historicallows_Error1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Historicallows_Error1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_historicallows_error1(inputs)
	if (locale === "ms") return ms_home_historicallows_error1(inputs)
	if (locale === "da") return da_home_historicallows_error1(inputs)
	if (locale === "de") return de_home_historicallows_error1(inputs)
	if (locale === "en-US") return en_us2_home_historicallows_error1(inputs)
	if (locale === "es-ES") return es_es2_home_historicallows_error1(inputs)
	if (locale === "es-MX") return es_mx2_home_historicallows_error1(inputs)
	if (locale === "fil") return fil_home_historicallows_error1(inputs)
	if (locale === "fr") return fr_home_historicallows_error1(inputs)
	if (locale === "it") return it_home_historicallows_error1(inputs)
	if (locale === "hu") return hu_home_historicallows_error1(inputs)
	if (locale === "nl") return nl_home_historicallows_error1(inputs)
	if (locale === "no") return no_home_historicallows_error1(inputs)
	if (locale === "pl") return pl_home_historicallows_error1(inputs)
	if (locale === "pt-BR") return pt_br2_home_historicallows_error1(inputs)
	if (locale === "pt") return pt_home_historicallows_error1(inputs)
	if (locale === "ro") return ro_home_historicallows_error1(inputs)
	if (locale === "fi") return fi_home_historicallows_error1(inputs)
	if (locale === "sv") return sv_home_historicallows_error1(inputs)
	if (locale === "vi") return vi_home_historicallows_error1(inputs)
	if (locale === "tr") return tr_home_historicallows_error1(inputs)
	if (locale === "cs") return cs_home_historicallows_error1(inputs)
	if (locale === "bg") return bg_home_historicallows_error1(inputs)
	if (locale === "ru") return ru_home_historicallows_error1(inputs)
	if (locale === "uk") return uk_home_historicallows_error1(inputs)
	if (locale === "ar") return ar_home_historicallows_error1(inputs)
	if (locale === "hi") return hi_home_historicallows_error1(inputs)
	if (locale === "th") return th_home_historicallows_error1(inputs)
	if (locale === "ja") return ja_home_historicallows_error1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_historicallows_error1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_historicallows_error1(inputs)
	return ko_home_historicallows_error1(inputs)
});
export { home_historicallows_error1 as "home.historicalLows.error" }